import { useEffect } from 'react';
import { useData } from '../../context/DataContext';
import { useToast } from '../../context/ToastContext';
import { getDueRecurringExpenseCategories } from '../utils/expenseReminders';

export function useExpenseReminders() {
  const { expenseCategories, expenses, cloudUser, appSettings } = useData();
  const { showToast, clearNotificationsByRelated } = useToast();

  useEffect(() => {
    if (!cloudUser || !appSettings.isSetupComplete || expenseCategories.length === 0) return;

    const todayStr = new Date().toISOString().split('T')[0];
    if (localStorage.getItem('recurringReminderDate') === todayStr) return;

    const now = new Date();
    const today = now.getDate();

    const missing = getDueRecurringExpenseCategories(expenseCategories, expenses, now);

    if (missing.length === 0) return;

    localStorage.setItem('recurringReminderDate', todayStr);
    missing.forEach(cat => {
      const dueDay = cat.recurringDay!;
      const diff = dueDay - today;
      const msg = diff > 0
        ? `${cat.name} — ${diff} gün sonra ödenmeli`
        : diff === 0
        ? `${cat.name} — bugün ödenmeli`
        : `${cat.name} — ${Math.abs(diff)} gün gecikti`;
      clearNotificationsByRelated('expenseCategory', String(cat.id));
      showToast(msg, diff < 0 ? 'error' : 'info', { id: String(cat.id), type: 'expenseCategory' });
    });
  }, [cloudUser, appSettings.isSetupComplete, expenseCategories, expenses, showToast, clearNotificationsByRelated]);
}
